const en = {
  s1_title: "Nirooban",
  s1_description:
    "Nirooban is a green startup in the field of energy management, whose goal is to control electricity consumption during peak by providing online information on shared consumption through a mobile phone application",
  enterPhoneNumber: "Enter your mobile phone number",
  callMe: "Call Me!",
  sent: "Sent!",
  s2_title: "Display information online",
  s2_description:
    "By displaying online information, in addition to reducing your consumption and reducing your cost by half, it also reduces the overall electricity consumption during peak hours.",
  s3_title: "Cost increase warning",
  s3_description:
    "When the common electricity consumption goes out of normal, according to the continuous monitoring of the business intelligence on his consumption and consumption history, it warns him and suggests ways to reduce consumption as well as the best energy consumption pattern.",
  s4_title: "Electrical diagram",
  s4_description:
    "In this section, you can view and compare the consumption dates of previous months in a graph",
  s5_title: "smart Home",
  s5_description:
    "Using this part of the application, turn off the lights of other rooms that are empty and prevent peak consumption, and also measure the temperature, level of pollution and humidity of the home.",
  s6_title: "Experience the smart home right now!",
  s6_description:
    "To use this demo, log in with a laptop or mobile first and scan the following QR code with another mobile and control our demo with the application that appears.",
  contactUs: "Contact us",
  name: "Name and surname",
  phoneNumber: "Mobile",
  city: "City",
  subject: "Message subject",
  email: "Email",
  text: "Message text",
  sendPm: "Send message",
  sentPm: "Your message has been sent!",
  copyright: "All rights of this site are reserved and belong to Niroban.",
  whatsapp: "Whatsapp:+989368819962",
  app_monitor: "Control and monitoring system",
  app_power: "electricity consumption",
  app_userId: "username",
  app_password: "password",
  app_login: "Login",
  app_currentUsage: "current usage",
  app_voltUnit: "V",
  app_amperUnit: "A",
  app_periodUsage: "Periodic Usage",
  app_kwh: "KWH",
  app_cost: "cost",
  app_priceUnit: "Toman",
  app_status: "status",
  app_customerStatus: "Low consumption subscriber",
  app_moreDetail: " more detail",
  app_dearCustomer:'Dear Subscriber',
  app_notification:'Your consumption has exceeded the limit, please turn off the extra electrical appliances by entering the smart home section',
  app_analyze:'Consumption analysis',
  lamp:"light",
  on:'ON',
  off:"OFF",
  split:'Fan',
  humidity:"Humidity",
  co2:"CO2",
  temp:'Temp'
};

export default en;
